<template>
  <v-container fluid id="team-page">
    <v-row class="mt-6 justify-center">
      <v-col cols="10">
        <h1 id="title">Meet the Team</h1>
        <img
          class="mt-n3 mb-3"
          :src="require(`../assets/gold-line.svg`)"
          alt="Gold line"
        />
      </v-col>
      <v-col cols="10" class="mt-n6">
        <VueSlickCarousel v-bind="settings" class="carousel">
          <img
            class="img-slider-2"
            :src="require(`../assets/brown-cat.png`)"
            alt="Cat"
          />
          <img
            class="img-slider-2"
            :src="require(`../assets/black-cat.png`)"
            alt="Cat"
          />
          <img
            class="img-slider-2"
            :src="require(`../assets/orange-cat.png`)"
            alt="Cat"
          />
          <img
            class="img-slider-2"
            :src="require(`../assets/grey-cat.png`)"
            alt="Cat"
          />
          <img
            class="img-slider-2"
            :src="require(`../assets/grey-cat.png`)"
            alt="Cat"
          /><img
            class="img-slider-2"
            :src="require(`../assets/grey-cat.png`)"
            alt="Cat"
          /><img
            class="img-slider-2"
            :src="require(`../assets/grey-cat.png`)"
            alt="Cat"
          /><img
            class="img-slider-2"
            :src="require(`../assets/grey-cat.png`)"
            alt="Cat"
          />
        </VueSlickCarousel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "Team",
  components: { VueSlickCarousel },

  data() {
    return {
      settings: {
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 3,
        touchThreshold: 5,
        dots: true,
      },
    };
  },
};
</script>
<style>
.img-slider-2 {
  width: 16.2vw !important;
}
</style>
<style scoped>
#title {
  color: white !important;
  font-weight: 500 !important;
  font-size: 5vw !important;
  line-height: 5vw !important;
  margin-top: -30px;
}

#team-page {
  color: white;
  height: calc(100vh - 80px);
  background: #141414;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.glow-button {
  text-decoration: none;
  color: white !important;
  background: linear-gradient(
    135deg,
    rgba(217, 173, 89, 1) 0%,
    rgba(162, 128, 62, 1) 100%
  );
  padding: 15px 40px;
  border-radius: 4px;
  font-weight: normal;
  box-shadow: 0 0 15px rgb(255, 255, 255, 0.4) !important;
  font-size: 2vw !important;
  cursor: pointer;
  margin-bottom: 20px;
}
@media screen and (max-width: 961px) {
  .img-slider-2 {
    width: 22vw !important;
  }
  #title {
    font-size: 7vw !important;
    line-height: 7vw !important;
  }
}
@media screen and (max-width: 821px) {
  .glow-button {
    font-size: 4vw !important;
  }
}
</style>
